import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/crispy bites/butter.png";
import BiscuitImg from "../../../assets/products/crispy bites/Butter-Cookies.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: "TIN-" + 114,
  },
  {
    grams: 150,
  },
  {
    grams: 340,
  },
  {
    grams: 454,
  },
  {
    grams: 500,
  },
  {
    grams: 908,
  },
  {
    grams: "POUCH-" + 150,
  },
];

export default function ButterProduct() {
  return (
    <>
      <Helmet>
        <title>
          Crispy Butter Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Crispy Butter Biscuits — rich buttery flavor with a satisfying crunch. View pack sizes, cartons, and global specs."
        />
        <meta
          name="keywords"
          content="Crispy Butter Biscuit, BearBitz Butter Biscuit"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/crispy-biscuit/butter"
        />
        <meta property="og:title" content="Crispy Butter Biscuit – BearBitz" />
        <meta
          property="og:description"
          content="Buttery, crisp biscuits by BearBitz designed for premium quality and export standards."
        />
      </Helmet>

      <ProductTemplate
        productTitle="BUTTER COOKIES"
        productImage={BisImg}
        description="Experience the timeless taste of Danish Butter Cookies – golden, crisp, and melt-in-your-mouth buttery. Perfectly baked to bring you moments of comfort, joy, and a touch of tradition in every bite."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#001C87"
        sectionBgColor="#ADBEFF"
        productBgcolor="#DEE5FF"
        tableheadBgcolor="#001C87"
        tableBgcolor="#DEE5FF"
        footerBgcolor="#001C87"
      />
    </>
  );
}
